var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_3._linke",
    "data-name": "3. linke",
    d: "M51.5,103A51.513,51.513,0,0,1,31.454,4.047,51.513,51.513,0,0,1,71.546,98.953,51.178,51.178,0,0,1,51.5,103Zm9.882-51.6c2.523,0,4.159,1.036,5,3.168a18.1,18.1,0,0,1,.751,6.269v17.35H78.192V58.613c0-8.807-1.606-16.957-13.261-16.957A11.688,11.688,0,0,0,54.46,47.412h-.155V42.55H43.691V78.192H54.746V60.544c0-2.911.358-4.858,1.16-6.313C56.955,52.329,58.746,51.4,61.382,51.4ZM25.69,42.55V78.192H36.758V42.55Zm5.528-17.742a6.44,6.44,0,1,0,6.41,6.41A6.417,6.417,0,0,0,31.217,24.809Z",
    fill: "#3478b4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.32bb89ce437941a3fe773bcdd638854c.svg";
export { ForwardRef as ReactComponent };